import moment from 'moment'

const mountDefault = (incident) => {
  const incidentViolationTypes = incident?.incidentViolationTypes?.map(
    (item) => {
      return {
        id: item?.value,
      }
    },
  )
  delete incident['legalOpinion']

  if (incident?.legalOpinion) {
    delete incident.legalOpinion
  }

  return {
    ...incident,
    incidentViolationTypes,
    ...incident?.dataOptionIncidents,
    ...incident?.incidentDataAgents,
    ...incident?.communicationIncidentHolder,
    ...incident?.incidentReporting,
    incidentHour: moment(incident?.incidentDatetime).format('HH:mm:ss') || '',
    incidentDate: moment(incident?.incidentDatetime).format('DD/MM/YYYY') || '',
  }
}

export default mountDefault
